export default __webpack_public_path__ + "assets/left-arrow-blue.1642db31.svg";